import { render, staticRenderFns } from "./LandingCards.vue?vue&type=template&id=59b41a1a&scoped=true&"
import script from "./LandingCards.vue?vue&type=script&lang=js&"
export * from "./LandingCards.vue?vue&type=script&lang=js&"
import style0 from "./LandingCards.vue?vue&type=style&index=0&id=59b41a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b41a1a",
  null
  
)

export default component.exports